<div class="entity-connection-group-table"
     [ngClass]="{'no-connections': totalCount === 0}">
  <div class="table mt-0100">
    <div class="tr tile__heading tr--noGutter">
      <button mat-icon-button
              *ngIf="totalCount > 0"
              type="button"
              matTooltip="View all connections on wall chart page"
              aria-label="View all connections on wall chart page"
              class="ml-0 w-auto h-auto lh-normal"
              (click)="runConnectedToQuery()">
        <mat-icon fontSet="fal"
                  fontIcon="fa-th-list"
                  class="mr-0025"></mat-icon>
      </button>
      <app-connection-type-name class="ml-0"
                                [connectionType]="entityConnectionType"></app-connection-type-name> <i
         class="fal fa-share-alt ml-0025"></i>
      <ng-container *ngIf="showTaskDoneMark">
        <span class="color--gray ml-0050">
          &bull;
          <span class="color--green">
            <span class="d-none d-inline--md uppercase ml-0025">Done</span>
            <i class="far fa-check ml-0025"></i>
          </span>
        </span>
      </ng-container>
      <button mat-button
              class="addNew ml-auto"
              (click)="openAddConnectionDialog()">
        <i class="far fa-plus addNew__icon"></i> Add
      </button>

    </div>

    <div class="scrollable"
         *ngIf="totalCount > 0">
      <app-entity-connection-row *ngFor="let con of visibleConnections; trackBy:trackByIdFn;"
                                 [entityId]="entityId"
                                 [campaignId]="campaignId"
                                 [entityConnectionTypeId]="entityConnectionType.id"
                                 [entityConnection]="con">
      </app-entity-connection-row>
    </div>

    <div class="tr-wrapper"
         *ngIf="totalCount === 0">
      <div class="tr txt-13 pt-0050 pb-0050">
        <em class="color--gray">0 results</em>
      </div>
    </div>

    <div class="tr tr--noGutter tile__footing pt-0050 pb-0050 flexJustify-between txt-reset">
      <div class="txt-14 color--gray--005">
        <span class="d-none d-inline--sm">
          Showing <strong>{{visibleConnections?.length || 0}}</strong> of <strong>{{totalCount}}</strong>.
        </span>
        <button mat-button
                (click)="loadMoreClicked()"
                class="h-auto uppercase pl-0050 pr-0050 pt-0025 pb-0025 lh-normal txt-13 color--blue"
                *ngIf="pageInfo?.hasNextPage">Load More…</button>
      </div>
      <mat-checkbox class="txt-14 color--gray--005 mt-0050neg mb-0050neg"
                    [checked]="includeInactiveChecked"
                    (change)="showInactiveCheckboxChanged($event)">
        <span class="nowrap">Show inactive</span>
      </mat-checkbox>
    </div>
  </div>
</div>
